import React from "react";
import { Input as AntInput } from 'antd';

const componentClass = 'fieldType__textArea';

const TextArea = ({ onChange, value, ...rest }) => {
  const onValueChange = e => {
    onChange(e.target.value);
  };

  return <AntInput.TextArea
      className={componentClass}
      onChange={onValueChange}
      value={value}
      {...rest}
  />
}
export default TextArea;
